import Vue from 'vue';
import VueRouter from 'vue-router';

import UserRoutes from './users';
import DocumentRoutes from './documents';
import SituationRoutes from './situations';
import GameRoutes from './games';
import { useRootStore } from '../stores/root';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: '/dashboard'
        },
        {
            path: '/error',
            name: 'error',
            component: () => import('../pages/ErrorPage'),
            props: route => ({
                code: route.params.code,
                errorKey: route.params.errorKey
            })
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('../pages/Dashboard'),
            meta: {
                auth: true
            }
        },
        {
            path: '/change-lecturer',
            name: 'change.lecturer',
            component: () => import('../pages/ChangeLecturer'),
            meta: {
                auth: true,
                player: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('../pages/Login'),
            meta: {
                guest: true
            }
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('../pages/Register'),
            meta: {
                guest: true
            }
        },
        {
            path: '/profile',
            name: 'profile',
            component: () => import('../pages/EditProfile'),
            meta: {
                auth: true
            }
        },
        ...UserRoutes,
        ...DocumentRoutes,
        ...SituationRoutes,
        ...GameRoutes
    ]
});

router.beforeEach((to, from, next) => {
    const rootStore = useRootStore();
    
    rootStore.authenticate();
    rootStore.clearErrors();

    if (from.name && (from.name.includes('.index') || from.name === 'dashboard'))
        rootStore.clearNotifications();

    if (to.matched.some(record => record.meta.auth) && !rootStore.authenticated)
        next({ name: 'login' });
    else if (to.matched.some(record => record.meta.guest) && rootStore.authenticated)
        next({ name: 'dashboard' });
    else {
        const user = rootStore.user;
        let roleType = null;

        if (rootStore.authenticated && !user)
            rootStore.setLoading(true);

        if (to.matched.some(record => record.meta.admin)) {
            roleType = 'admin';
        } else if (to.matched.some(record => record.meta.lecturer)) {
            roleType = 'lecturer';
        }  else if (to.matched.some(record => record.meta.player)) {
            roleType = 'player';
        }

        if (rootStore.authenticated && !user) {
            initUser(next, roleType);
        } else if (user) {
            resolveRoleRedirection(user, roleType, next);
        } else {
            next();
        }
    }
});

function resolveRoleRedirection(user, roleType, next) {
    if (roleType && (!user.role || roleType !== user.role.key))
        next({ name: 'dashboard' });
    else
        next();
}

function initUser(next, requestedRoleType = null, to = null) {
    const rootStore = useRootStore();
    
    rootStore.authUser()
        .then(user => {
            rootStore.setUser(user);
            rootStore.initWebSocket();
            rootStore.setLoading(false);
            
            resolveRoleRedirection(user, requestedRoleType, next);
        })
        .catch(() => {
            rootStore.setLoading(false);
            rootStore.logout();

            next({ name: 'login' });
        })
}

export default router;
